import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  Input,
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Location, LocationStrategy } from "@angular/common";
import {
  FormControl,
  FormArray,
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { SubscriptionLike as ISubscription } from "rxjs";

import { CitLicenseGeneratorService } from "./cit-license-generator.service";
import {
  LicenseSummaryResponseModel,
  AuthCodeEmailModel,
  RequestAuthCodeORVersionUpgradeModel,
  productArray,
  UserInfo,
} from "./cit-license-summary.model";
import { NgbModal, ModalDismissReasons } from "bootstrap";
import { CitGlobalConstantService } from "../core/cit-global-constants.service";
declare var assetBasePaths;

@Component({
  selector: "app-cit-licence-generator",
  templateUrl: "./cit-licence-generator.component.html",
  styleUrls: ["./cit-licence-generator.component.css"],
})
export class CitLicenceGeneratorComponent implements OnInit, OnDestroy {
  @ViewChild("closeBtn", { static: true }) closeBtn: ElementRef;
  @ViewChild("alertNotice", { static: true }) alertNotice: ElementRef;
  @ViewChild("alertBody") alertBody: ElementRef;
  @ViewChild("clipboard") clipboard: ElementRef;

  private subscriptions: ISubscription[] = [];

  ctx = { estimate: "details" };
  public activeTab: string = "LicenseGenerator";
  public submissionForm: FormGroup;
  public authcodeForm: FormGroup;
  public usbSerialPrefixOptions: any[] = [];

  public licenseAuthCodes: any;
  public alert: any;
  public licenseSummary: any;
  public isUsbKeySerialNumberEntered: Boolean;
  public citEmail: string;
  public citEmailContext: any;
  public queryParam: any;

  public randomCaptchaCode: any;
  public validCaptcha: string;
  //RequestAuthCode PROPERTIES
  public requestAuthCodeProductType: string;
  public requestAuthCodeContactName: string;
  public requestAuthCodeContactEmail: string;
  public requestAuthCodeCompany: string = "Citect - Returns";

  public sitesObject: any;

  public isProgress: boolean = false;
  public productArray = productArray;
  public copiedToClipboard: boolean = false;
  public userInfo: UserInfo;

  //public ciUSafeDownloadURL: string;
  //public sentinelDownloadURL: string;
  //public floatingLicenseManagerURL: string;
  public iban_no: string;
  public tooltipData: any;
  public ciUSafeDownloadsData: any;
  public floatingLicenseData: any;
  public installationSteps: any;
  public tableData: any;
  public assetPathVar: string = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private locationStrategy: LocationStrategy,
    private fb: FormBuilder,
    private licenseGenSvc: CitLicenseGeneratorService,
    public citGlobalConstantService: CitGlobalConstantService
  ) {
    this.licenseSummary = new LicenseSummaryResponseModel();
    //this.ciUSafeDownloadURL = this.citGlobalConstantService.licenseGenearatorURL + "/CiUSafe_8_10_0_2086.zip";
    //this.sentinelDownloadURL = this.citGlobalConstantService.licenseGenearatorURL + "/Sentinel_Driver_7.6.0.zip";
    //this.floatingLicenseManagerURL = this.citGlobalConstantService.licenseGenearatorURL + "/Floating_License_Manager_v2.1.0.0.zip";
  }

  ngOnInit() {
    this.assetPathVar = assetBasePaths;
    this.initSubmissionForm();
    this.generateAuthcodeForm();
    this.populateUsbSerialPrefixOptions();
    this.subscriptions.push(
      this.licenseGenSvc.userInfoObservable.subscribe(
        (userInfo) => {
          if (userInfo != null && userInfo != undefined) {
            this.citEmail = userInfo.Email;
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );
    this.subscriptions.push(
      this.activatedRoute.queryParams.subscribe((params: Params) => {
        var paramsRequestToken = params["requestToken"];
        console.info("requestToken", paramsRequestToken);

        if (paramsRequestToken)
          this.licenseGenSvc.getRequestToken(paramsRequestToken);

        var selectedTab = <string>params["selectedTab"];
        if (
          selectedTab != undefined &&
          selectedTab != null &&
          selectedTab.length > 0
        ) {
          switch (selectedTab.toLowerCase()) {
            case "licensegenerator":
              // case "help":
              // case "ciusafe":
              // case "floatinglicensemanager":
              this.onTabSelectionChanged(selectedTab);
              break;
            default:
              this.onTabSelectionChanged("LicenseGenerator");
              break;
          }
        } else {
          this.onTabSelectionChanged("LicenseGenerator");
        }
      })
    );

    //this.subscriptions.push(
    //  this.licenseGenSvc
    //    .getDataForRequestUrl(`${assetBasePaths}` + "/data/licensetooltip.json")
    //    .subscribe((response) => {
    //      this.tooltipData = response;
    //    })
    //);

    this.subscriptions.push(
      this.licenseGenSvc
        .getDataForRequestUrl(`${assetBasePaths}` + "/data/safedownloads.json")
        .subscribe((response) => {
          let data;
          if (response != null) data = response;
          this.ciUSafeDownloadsData = data.downloadData;
          this.installationSteps = data.installationSteps;
          this.tableData = data.tableData;
        })
    );

    this.subscriptions.push(
      this.licenseGenSvc
        .getDataForRequestUrl(
          `${assetBasePaths}` + "/data/floatinglicensedata.json"
        )
        .subscribe((response) => {
          this.floatingLicenseData = response;
        })
    );
  }

  ngOnDestroy() {
    if (this.subscriptions != null && this.subscriptions.length > 0) {
      for (let subscription of this.subscriptions) {
        subscription.unsubscribe();
      }
    }
  }
  generateCaptcha() {
    var alpha = new Array(
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    );
    var numric = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    var i;
    for (i = 0; i < 6; i++) {
      var a = alpha[Math.floor(Math.random() * alpha.length)];
      var b = alpha[Math.floor(Math.random() * alpha.length)];
      var c = alpha[Math.floor(Math.random() * alpha.length)];
      var d = alpha[Math.floor(Math.random() * alpha.length)];
      var e = numric[Math.floor(Math.random() * numric.length)];
      var f = numric[Math.floor(Math.random() * numric.length)];
    }
    this.randomCaptchaCode =
      a + "" + b + "" + e + "" + "" + c + "" + d + "" + f;
    this.authcodeForm.patchValue({ captchaCode: null });
  }

  validateCaptcha(data: any) {
    if (data) {
      this.validCaptcha = "";
      if (data === this.randomCaptchaCode) {
        this.validCaptcha = "valid";
      } else {
        this.generateCaptcha();
        this.validCaptcha = "invalid";
        this.authcodeForm.patchValue({ captchaCode: "" });
      }
    }
  }
  onTabSelectionChanged(tab: string) {
    if (tab == null || tab.length == 0) tab = "Downloads";

    this.activeTab = tab;
    if (tab.toLowerCase() == "downloads") this.location.replaceState("", ``);
    else this.location.replaceState("", `selectedTab=${tab}`);
  }

  initSubmissionForm() {
    this.submissionForm = this.fb.group({
      usbSerialPrefix: "",
      usbSerialSuffix: "",
      activationId: ["", Validators.minLength(16)],
    });
  }

  generateAuthcodeForm() {
    this.authcodeForm = this.fb.group({
      keySerialNumber: [""],
      activationId: [""],
      siteNumber: ["", Validators.required],
      product: ["", Validators.required],
      contactName: ["", Validators.required],
      contactEmail: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9_]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,3})$/
          ),
        ]),
      ],
      companyName: ["", Validators.required],
      captchaCode: ["", Validators.required],
    });
  }

  onSubmit() {
    var formModel = this.submissionForm.value;
    //Submit these value via service and populate the result
    if (
      (formModel.usbSerialPrefix != null && formModel.usbSerialPrefix.length) >
      0 &&
      formModel.usbSerialSuffix != null &&
      formModel.usbSerialSuffix.length > 0
    ) {
      this.submissionForm.get("activationId").setValue("");

      this.isProgress = true;
      this.licenseGenSvc
        .getLicenseDetailsForUsbKey(
          `${formModel.usbSerialPrefix}${formModel.usbSerialSuffix}`
        )
        .subscribe((result) => {
          this.isProgress = false;
          this.licenseSummary = new LicenseSummaryResponseModel();
          this.licenseSummary = result;
          this.licenseSummary.keySerialNumber =
            this.getEnteredUsbSerialNumber();
          this.citEmailContext = null;
          //Different API.
          //this.getSiteDataForSiteId(result.siteId);
          console.info("License Summary response::", this.licenseSummary);
          const licenseGeneratorFormcollapseElement = document.getElementById(
            "licenseGeneratorForm"
          );
          const licenseGeneratorResultcollapseElement = document.getElementById(
            "licenseGeneratorResult"
          );
          if (licenseGeneratorFormcollapseElement != null) {
            licenseGeneratorFormcollapseElement.className = "collapse hide";
          }
          if (licenseGeneratorResultcollapseElement != null) {
            licenseGeneratorResultcollapseElement.className = "collapse show";
          }
        });
    } else if (
      formModel.activationId != null &&
      formModel.activationId.length > 0
    ) {
      //Set inital prefix
      this.usbSerialPrefixOptions.forEach((x) => {
        if (x.isSelected) {
          this.submissionForm.get("usbSerialPrefix").setValue(x.value);
        }
      });

      this.isProgress = true;
      this.licenseGenSvc
        .getLicenseDetailsForSoftwarekey(`${formModel.activationId}`)
        .subscribe(
          (result) => {
            console.log(result);

            this.licenseSummary = new LicenseSummaryResponseModel();
            this.licenseSummary = result;
            this.licenseSummary.activationId = formModel.activationId;

            //Different API.
            //  this.getSiteDataForSiteId(result.siteId);
          },
          (error) => {
            console.error(error);
            this.isProgress = false;
          }
        );
    }
  }

  //==================
  //HTML binding events.
  //==================
  getSiteId() {
    var formModel = this.submissionForm.value;
    if (
      (formModel.usbSerialPrefix != null && formModel.usbSerialPrefix.length) >
      0 &&
      formModel.usbSerialSuffix != null &&
      formModel.usbSerialSuffix.length > 0
    ) {
      var usbSerialPrefixDisplayValue = "";
      if (this.usbSerialPrefixOptions != null) {
        this.usbSerialPrefixOptions.forEach((x) => {
          if (x.value == formModel.usbSerialPrefix) {
            usbSerialPrefixDisplayValue = x.displayValue;
          }
        });
      }
      return `${usbSerialPrefixDisplayValue}-${formModel.usbSerialSuffix}`;
    }
    return null;
  }
  getEnteredUsbSerialNumber() {
    var formModel = this.submissionForm.value;

    if (
      (formModel.usbSerialPrefix != null && formModel.usbSerialPrefix.length) >
      0 &&
      formModel.usbSerialSuffix != null &&
      formModel.usbSerialSuffix.length > 0
    ) {
      var usbSerialPrefixDisplayValue = "";
      if (this.usbSerialPrefixOptions != null) {
        this.usbSerialPrefixOptions.forEach((x) => {
          if (x.value == formModel.usbSerialPrefix) {
            usbSerialPrefixDisplayValue = x.displayValue;
          }
        });
      }

      return `${usbSerialPrefixDisplayValue}-${formModel.usbSerialSuffix}`;
    }
    return null;
  }

  isEmptyObject(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }

    return true;
  }

  showRequestVersionUpdate() {
    if (
      this.licenseSummary.keySerialNumber == undefined ||
      this.licenseSummary.keySerialNumber.length == 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  copyToClipboard(inputElement) {
    inputElement.select();
    document.execCommand("copy");
    inputElement.setSelectionRange(0, 0);
    this.clipboard.nativeElement.className = "show";
    let self = this;
    setTimeout(function () {
      self.clipboard.nativeElement.className = "";
    }, 2000);
  }

  sendEmail() {
    var authcodeEmail = new AuthCodeEmailModel();
    authcodeEmail.AuthorizationCode =
      this.licenseSummary.authCode.AuthorizationCode;
    authcodeEmail.AuthorizationCodeCitect =
      this.licenseSummary.authCode.AuthorizationCodeCitect;
    authcodeEmail.AuthorizationCodeVijeo =
      this.licenseSummary.authCode.AuthorizationCodeVijeo;

    authcodeEmail.AuthorizationCodeHash =
      this.licenseSummary.authCode.AuthorizationCodeHash;
    authcodeEmail.AuthorizationCodeCitectHash =
      this.licenseSummary.authCode.AuthorizationCodeCitectHash;
    authcodeEmail.AuthorizationCodeVijeoHash =
      this.licenseSummary.authCode.AuthorizationCodeVijeoHash;

    authcodeEmail.Email = this.citEmail;
    authcodeEmail.KeySerialNumber = this.getEnteredUsbSerialNumber();

    this.isProgress = true;
    this.licenseGenSvc
      .sendAuthCodeviaEmail(authcodeEmail)
      .subscribe((result) => {
        if (result == true) {
          this.citEmailContext = {
            details: "Successfully email sent.",
          };
        } else {
          this.citEmailContext = {
            details: "Email has not sent.",
          };
        }
        this.isProgress = false;
      });
  }

  sendEmailAuthCodeRequestEmail(isAuthCodeRequestUpdate) {
    var formModel = this.authcodeForm.value;
    if (this.authcodeForm.valid) {
      var requestAuthCodeORVersionUpgrade =
        new RequestAuthCodeORVersionUpgradeModel();

      requestAuthCodeORVersionUpgrade.ActivationId = isAuthCodeRequestUpdate
        ? null
        : formModel.activationId;
      requestAuthCodeORVersionUpgrade.USBKeySerialNumber =
        isAuthCodeRequestUpdate ? formModel.keySerialNumber : null;

      requestAuthCodeORVersionUpgrade.Company = formModel.companyName;
      requestAuthCodeORVersionUpgrade.ContactEmail = formModel.contactEmail;
      requestAuthCodeORVersionUpgrade.ContactName = formModel.contactName;
      requestAuthCodeORVersionUpgrade.SiteId = formModel.siteNumber;
      requestAuthCodeORVersionUpgrade.ProductType = formModel.product;

      this.isProgress = true;
      this.licenseGenSvc
        .sendEmailForVersionUpgradeORRequestAuthCode(
          requestAuthCodeORVersionUpgrade
        )
        .subscribe(
          (result) => {
            this.closeBtn.nativeElement.click();
            this.citEmailContext = {
              details: result.message,
            };

            this.isProgress = false;
          },
          (error) => {
            this.citEmailContext = {
              details: "Email has not sent.",
            };

            this.isProgress = false;
          }
        );
    }
  }

  requestAuthCodeButtonClick(isAuthCodeRequestUpdate) {
    this.generateCaptcha();

    var usbKeySerialNo = isAuthCodeRequestUpdate
      ? this.getEnteredUsbSerialNumber()
      : "";
    var activationId = isAuthCodeRequestUpdate
      ? ""
      : this.submissionForm.value.activationId;

    var userName = this.licenseGenSvc.userinfoCache.UserName;
    var email = this.licenseGenSvc.userinfoCache.Email;

    this.authcodeForm.patchValue({
      keySerialNumber: usbKeySerialNo,
      activationId: activationId,
      siteNumber: this.licenseSummary.siteId,
      product: "",
      contactName: userName == null || userName == undefined ? "" : userName,
      contactEmail: email == null || email == undefined ? "" : email,
      companyName: this.sitesObject.name,
      captchaCode: "",
    });
  }

  //PRIVATE METHODS.
  //private populateUsbSerialPrefixOptions() {
  //  var formModel = this.submissionForm.value;
  //  this.isProgress = true;
  //  this.licenseGenSvc.getKeySerialNumberFirstPart().subscribe(
  //    (result) => {
  //      this.usbSerialPrefixOptions = result;
  //      this.isProgress = false;
  //      this.usbSerialPrefixOptions.forEach((x) => {
  //        if (x.isSelected) {
  //          this.submissionForm.get("usbSerialPrefix").setValue(x.value);
  //        }
  //      });
  //    },
  //    (error) => {
  //      console.error(error);
  //      this.isProgress = false;
  //    }
  //  );
  //}

  private populateUsbSerialPrefixOptions(): void {
    this.isProgress = true;

    this.licenseGenSvc.getKeySerialNumberFirstPart().subscribe({
      next: (result) => {
        if (Array.isArray(result)) {
          this.usbSerialPrefixOptions = result;

          const selected = result.find(x => x.isSelected);
          if (selected) {
            this.submissionForm.get('usbSerialPrefix')?.setValue(selected.value);
          }
        }

        this.isProgress = false;
      },
      error: (error) => {
        console.error('Error loading USB serial prefixes:', error);
        this.isProgress = false;
      }
    });
  }

  //private getSiteDataForSiteId(siteId) {
  //  this.licenseGenSvc.getSitesForSIteID(siteId).subscribe(
  //    (result) => {
  //      this.isProgress = false;
  //      if (result) {
  //        this.sitesObject = result;
  //      }
  //    },
  //    (error) => {
  //      this.isProgress = false;
  //    }
  //  );
  //}

  private generateDummyAlert() {
    this.alert = {
      Title: "Notice",
      Details: "Demo Alert for Anil.",
    };
  }

  mychange(val) {
    console.log(val);
    if (val == undefined) return;
    const self = this;
    var value = "";
    this.iban_no = "";

    if (val.length == 1) {
      value = val + "-";
      this.iban_no = value;
    } else if (val.length > 1 && val.indexOf("-") < -1) {
      this.iban_no = addHyphenForFourNumber(val);
    } else {
      if (val.length > 1) {
        this.iban_no = addHyphenForFourNumber(val[0] + "-" + val.substr(1));
      }
    }

    function addHyphenForFourNumber(val): string {
      var strArray = val.split("-");
      if (strArray.length > 1) {
        let chIbn = "";
        for (var i = 1; i < strArray.length; i++) {
          chIbn = chIbn + strArray[i];
        }
        if (chIbn.length > 0) {
          chIbn = chIbn.match(new RegExp(".{1,4}", "g")).join("-");
        }
        console.log(chIbn);
        return strArray[0] + "-" + chIbn;
      }
    }
  }

  getLicensesPage() {
    window.location.href = "https://licenseactivation.wonderware.com";
  }

  public get disableFLMSoftKeySubmitButton(): boolean {
    if (this.submissionForm.controls["activationId"].value == undefined)
      return true;

    if (this.submissionForm.controls["activationId"].value == null) return true;

    if (this.submissionForm.controls["activationId"].value == "") return true;

    if (this.submissionForm.controls["activationId"].valid == false)
      return true;

    return false;
  }

  public get disableUSBSubmitButton(): boolean {
    if (this.submissionForm.controls["usbSerialSuffix"].value == undefined)
      return true;

    if (this.submissionForm.controls["usbSerialSuffix"].value == null)
      return true;

    if (this.submissionForm.controls["usbSerialSuffix"].value == "")
      return true;

    if (this.submissionForm.controls["usbSerialSuffix"].valid == false)
      return true;

    return false;
  }
}
